import About from '../components/about/About';
import FeaturedMenu from '../components/featured-menu/FeaturedMenu';
import Testimonial from '../components/testimonial/Testimonial';
import Delivery from '../components/delivery/Delivery';
import PartyTray from '../components/party-tray/PartyTray';
import Footer from '../components/footer/Footer';
import Hero2 from '../components/hero/Hero2';
import { SubjectProvider } from '../utils/contexts/SubjectContext';
import HolidayScheduleSection from '../components/opening-hours/HolidayScheduleSection';

function LandingPage() {

  return (
    <>

      <Hero2 />
      <About />
      <FeaturedMenu />
      <Testimonial />
      
      <HolidayScheduleSection />

      <Delivery />

      <SubjectProvider>
        <PartyTray />
        <Footer />
      </SubjectProvider>
    </>
  );
}

export default LandingPage;